<template>
  <div class="report-settings-content">
    <v-container container--fluid grid-list-md>
       <v-row justify="space-between" align="center">
        <v-col cols="12" sm="12" md="6" v-for="(item, index) in items" :key="index">
          <v-checkbox
            v-if="item.type === 'checkbox'"
            :label="item.text"
            v-model="clientInfo[item.key]"
          ></v-checkbox>
          <v-text-field
            v-if="item.type === 'text'"
            :label="item.text"
            v-model="clientInfo[item.key]"
            :error="isFieldInvalid(item.key)"
            outlined
          ></v-text-field>
            <v-list
              v-if="item.type === 'list'"
              :items="item.listItems"
            >
              <v-subheader>{{item.text}}</v-subheader>
              <v-list-item v-for="(listItem, index) in item.listItems" @click="" :key="index">
                <v-list-item-action>
                  <v-checkbox v-model="clientInfo[listItem.key]"></v-checkbox>
                </v-list-item-action>
                <v-list-item-content @click="clientInfo[listItem.key] = !clientInfo[listItem.key]">
                  <v-list-item-title>{{listItem.text}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
         </v-row>
      </v-container>
  </div>
</template>

<script>

import axios from "axios";
    // @group EditClient
    // Client Report Settings tab for EditClientPage
  export default {
    name: "ReportSettings",
    props: {
      // Client Object
      clientInfo: Object,
    },
    data() {
      return {
        items: [
          {text: 'Ops Email', key: 'ops_email', type: 'text'},
          {text: 'Billing Email', key: 'billing_email', type: 'text'},
          {text: 'Send ETA Report (8PM day before delivery)', key: 'report_eta', type: 'checkbox'},
          {text: 'Send Staging Report (8AM day before delivery)', key: 'report_staging', type: 'checkbox'},
          {
            text: 'Send Transaction Reports',
            key: 'report_transaction',
            type: 'list',
            listItems: [
              {text: '7AM', key: 'report_transaction_7'},
              {text: '11AM', key: 'report_transaction_11'},
              {text: '3PM', key: 'report_transaction_15'},
              {text: '5PM', key: 'report_transaction_17'}
            ]
          },          {
            text: 'Send SMS Report',
            key: 'report_sms',
            type: 'list',
            listItems: [
              {text: '7AM', key: 'report_sms_7'},
              {text: '11AM', key: 'report_sms_11'},
              {text: '3PM', key: 'report_sms_15'},
              {text: '5PM', key: 'report_sms_17'}
            ]
          },
          {text: 'Send Billing Report', key: 'report_billing', type: 'checkbox'},
        ]
      }
    },
    computed: {
      invalidFields() {
        return this.$store.state.invalidFields || [];
      },
      isFieldInvalid() {
        return (fieldName) => this.invalidFields.includes(fieldName);
      }
    }
  }
</script>

<style scoped>
.report-settings-content {}

.v-text-field,
.v-select,
.v-checkbox {
  margin-bottom: 8px;
}

.v-text-field.v-text-field--outlined >>> .v-input__control {
  min-height: 56px;
}

.v-text-field.v-text-field--outlined >>> .v-input__slot {
  min-height: 48px;
}
</style>



// WEBPACK FOOTER //
// src/components/util/Clients/ReportSettings.vue